import gsap, { Power2, Power4 } from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

import { GetBy } from "../_app/cuchillo/core/Element";
import { isDebug } from '../_app/cuchillo/core/Basics';
import { Ease } from '../_app/cuchillo/utils/Ease';

export default class Preloader {
    _container;
    _title;
    _images;
    _imagesWrapper;

    static currentIndex = 0;
    static lastTime = performance.now();
    static intervalTime = 280;
    static minInterval = 20;
    static speedFactor = 0.92;
    static loaded = false;

    static init() {
        this._container = GetBy.id('Preloader');

        if (isDebug) {
            this._container.style.display = "none";
            return;
        }

        this._wrapper = GetBy.class('wrapper', this._container);
        // gsap.set(this._wrapper, { height: 0 });
        gsap.set(this._wrapper, { opacity: 0 });

        this._imagesWrapper = GetBy.class('images', this._container);

        // this._title = new SplitText(GetBy.class('text', this._container)[0], {
        //     type: 'lines, words',
        //     linesClass: 'line-parent',
        //     wordsClass: 'line-child'
        // }).words;
        // gsap.set(this._title, { opacity: 0 });

        this._title = new SplitText(GetBy.class('text', this._container), {
            type: 'words, chars',
            wordsClass: 'line-parent',
            charsClass: 'line-child'
        }).chars;
        gsap.set(this._title, { opacity: 0 });

        this._images = GetBy.selector('img', this._container);
        gsap.set(this._images, { opacity: 0 });
    }

    static update(__progress) { }

    static hide(__call) {
        if (isDebug) {
            if (__call) __call();
            this._container.style.display = "none";
            return;
        }

        const loop = () => {
            const now = performance.now();

            if (now - this.lastTime > this.intervalTime) {
                this.lastTime = now;

                gsap.to(this._images[this.currentIndex], { opacity: 0, duration: 0 });
                this.currentIndex = (this.currentIndex + 1) % this._images.length;
                gsap.to(this._images[this.currentIndex], { opacity: 1, duration: 0 });

                if (this.loaded) this.intervalTime = Math.max(this.minInterval, this.intervalTime * this.speedFactor);

                if (this.intervalTime <= this.minInterval) {
                    gsap.ticker.remove(loop);

                    for (let i = 0; i < this._title.length; i++) {
                        const item = this._title[i];
                        // gsap.to(item, {
                        gsap.set(item, {
                            opacity: 0,
                            // duration: .5,
                            delay: .8 + i * 0.01,
                            ease: Power2.easeOut
                        });
                    }

                    gsap.to(this._imagesWrapper, {
                        width: '120%',
                        height: '120%',
                        duration: 1.3,
                        delay: 1,
                        ease: Ease.EASE_CUCHILLO_IN_OUT
                    });

                    gsap.to(this._images, {
                        scale: 1,
                        duration: 1.3,
                        delay: 1,
                        ease: Ease.EASE_CUCHILLO_IN_OUT
                    });

                    gsap.to(this._container, {
                        // y: '-100%',
                        // delay: 1.5,
                        // duration: 1.5,
                        opacity: 0,
                        delay: 1.6,
                        duration: .5,
                        ease: Ease.EASE_CUCHILLO_IN_OUT,
                        onComplete: () => {
                            this._container.style.display = "none";
                            if (__call) __call();
                        }
                    });
                }
            }
        }

        let delay = 0;
        gsap.to(this._wrapper, {
            // height: '100%',
            // duration: 2,
            opacity: 1,
            duration: .5,
            ease: Ease.EASE_CUCHILLO_IN_OUT
        });

        gsap.ticker.add(loop);

        // delay += 3;
        delay += 1;
        gsap.to(this._imagesWrapper, {
            width: '45vw',
            height: '27vw',
            duration: 1,
            delay,
            ease: Ease.EASE_CUCHILLO_IN_OUT
        });
        gsap.to(this._images, {
            scale: 1.8,
            duration: 1,
            delay,
            ease: Ease.EASE_CUCHILLO_IN_OUT
        });

        delay += .5;
        for (let i = 0; i < this._title.length; i++) {
            let call = () => { };
            if (i === this._title.length - 1) {
                call = () => { this.loaded = true; }
            }

            const item = this._title[i];
            gsap.set(item, {
                opacity: 1,
                delay: delay + .3 + i * 0.04,
                onComplete: () => {
                    call();
                }
            });
            // gsap.to(item, {
            //     opacity: 1,
            //     duration: 1,
            //     delay: delay + i * 0.1,
            //     ease: Power2.easeOut,
            // });
            // gsap.to(item, {
            //     color: "#0A0900",
            //     duration: 1.5,
            //     delay: delay + i * 0.06 + .4,
            //     ease: Power2.easeOut
            // });
        }
    }
}
